<template>
  <div class="getTouch my-5">
    <div class="text-center p-5 getTouch__contact">
      <h2 class="mx-auto center-header">Not sure what you need?</h2>
      <p class="mx-auto m-5 getTouch__contact-color">
        Contact us and our team will resolve your concerns
      </p>
      <router-link 
        class="button" 
        to="/contact" 
        aria-label="Navigate to contact page"
      >
        Get in Touch
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GetInTouch',
};
</script>

<style scoped>
.getTouch {
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.getTouch__contact {
  margin-bottom: 15vh;
  padding: 5rem;
}

.getTouch__contact-color {
  color: #1e5c88; 
  font-weight: bold; 
}

.center-header {
  text-align: center;
}

.button[data-v-bb50a5e4], button[data-v-bb50a5e4] {
  cursor: pointer;
  color: rgb(255, 255, 255);
  font-family: Poppins, sans-serif;
  font-weight: 400;
  font-size: 20px;
  padding: 0.875rem 2.1875rem;
  background: linear-gradient(270deg, rgb(99, 168, 234), rgb(31, 85, 186));
  border-radius: 30px;
  border-width: 0px;
  border-style: initial;
  border-color: initial;
  -o-border-image: initial;
  border-image: initial;
  text-decoration: none;
  transition: 0.3s ease-in-out;
  font-size: 20px;
}
.button:hover {
  background-color: #0056b3; 
}

@media (max-width: 768px) {
  .getTouch__contact-color {
    padding: 1rem;
  }
}
</style>
